<template>
    <div class="returnTop" @click="backTop">
        <div class="top-arrows"><img src="@/assets/home/topArrows.png" alt=""></div>
        <div class="top-word">回到顶部</div>
    </div>
</template>

<script>
export default {
  name: 'returnTop',
  data () {
    return {

    }
  },
  methods: {
    backTop () {
      const scrollToptimer = setInterval(function () {
        console.log('定时循环回到顶部')
        var top = document.body.scrollTop || document.documentElement.scrollTop
        var speed = top / 4
        document.documentElement.scrollTop -= speed
        if (top === 0) {
          clearInterval(scrollToptimer)
        }
      }, 30)
    }
  }
}
</script>

<style scoped lang="less">
.returnTop{
    position: fixed;
    top: 500px;
    right: 43px;
    width: 47px;
    height: 77px;
    background: #FFFFFF;
    box-shadow: 0px 4px 14px 0px rgba(206, 206, 206, 0.5);
    border-radius: 8px;
    .top-arrows{
        width: 47px;
        height: 39px;
        line-height: 39px;
        text-align: center;
        background: #3056D9;
        border-radius: 8px 8px 0px 0px;
    }
    .top-word{
        width: 47px;
        height: 38px;
        padding: 6px 11px 0 ;
        box-sizing: border-box;
        background: #FFFFFF;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #252728;
        line-height: 13px;
        border-radius: 0px 0px 8px 8px;
    }
}
</style>
